export default {"src":"/_next/static/media/help_circle.d5c3b8ea.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};